export default "__VITE_ASSET__Ca07oybL__"